import { ModelFace } from "@centricsoftware/model-viewer";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { Popover } from "@mui/material";
import useTheme from "@mui/material/styles/useTheme";
import { useStore } from "csi/state/hooks";
import { FlexRow } from "designSystem/index";
import { grey } from "designSystem/styles/color";
import { observer } from "mobx-react-lite";
import React, { useCallback, useState } from "react";
import FaceSelectBackIcon from "../icon/toolbar/faceSelectIcons/FaceSelectBackIcon";
import FaceSelectBottomIcon from "../icon/toolbar/faceSelectIcons/FaceSelectBottomIcon";
import FaceSelectFrontIcon from "../icon/toolbar/faceSelectIcons/FaceSelectFrontIcon";
import FaceSelectIcon from "../icon/toolbar/faceSelectIcons/FaceSelectIcon";
import FaceSelectLeftIcon from "../icon/toolbar/faceSelectIcons/FaceSelectLeftIcon";
import FaceSelectRightIcon from "../icon/toolbar/faceSelectIcons/FaceSelectRightIcon";
import FaceSelectTopIcon from "../icon/toolbar/faceSelectIcons/FaceSelectTopIcon";
import IconButton3D from "./IconButton3D";

const modelFaceIconButtonProps = {
	fontSize: 14,
	sx: {
		borderRadius: "0px !important",
	},
};


const FaceSelectMenu = observer(() => {
	const { palette } = useTheme();	
	const primary = palette.primary.main;
	const secondary = palette.NavListItemSelectedBG;
	
	const rootStore = useStore();
	const { threeDStore } = rootStore;
	const { handleSelectFace } = threeDStore;
   
	const [anchorEl, setAnchorEl] = useState(null);
   
	const toggleSelectFaceMenu = useCallback((e) => {
		setAnchorEl(e.currentTarget);
	}, []);

	const closeSelectFaceMenu = useCallback(() => {
		setAnchorEl(null);
	}, []);

	const selectFace = useCallback((face: ModelFace) => {
		handleSelectFace(face);
		closeSelectFaceMenu();
	}, [handleSelectFace, closeSelectFaceMenu]);

	const open = !!anchorEl; 

	return (
		<>
			<IconButton3D
				fontSize={14}
				onClick={toggleSelectFaceMenu}
				res="3DSelectFaces"
				sx={{
					backgroundColor : open ? secondary : "transparent",
				}} 
			> 
				<FaceSelectIcon selected={open} />
				<ArrowDropDownIcon 
					sx={{
						color: open ? primary : grey[800],
						fontSize: "15px !important",
						left: "17px",
						position: "absolute",
						top: "17px",
						transform: "rotate(315deg)",
					}}
				/>
			</IconButton3D>
			<Popover
				anchorEl={anchorEl}
				anchorOrigin={
					{
						vertical: "top",
						horizontal: 35,
					}
				}
				onClose={closeSelectFaceMenu}
				open={open}
				transformOrigin={
					{
						vertical: "top",
						horizontal: "left",
					}
				}
			>
				<FlexRow gap={1}>
					<IconButton3D {...modelFaceIconButtonProps} onClick={()=> selectFace(ModelFace.Front)}>
						<FaceSelectFrontIcon />
					</IconButton3D>
					<IconButton3D {...modelFaceIconButtonProps} onClick={()=> selectFace(ModelFace.Back)}>
						<FaceSelectBackIcon />
					</IconButton3D>
					<IconButton3D {...modelFaceIconButtonProps} onClick={()=> selectFace(ModelFace.Right)}>
						<FaceSelectRightIcon />
					</IconButton3D>
					<IconButton3D {...modelFaceIconButtonProps} onClick={()=> selectFace(ModelFace.Left)}>
						<FaceSelectLeftIcon />
					</IconButton3D>
					<IconButton3D {...modelFaceIconButtonProps} onClick={()=> selectFace(ModelFace.Top)}>
						<FaceSelectTopIcon />
					</IconButton3D>
					<IconButton3D {...modelFaceIconButtonProps} onClick={()=> selectFace(ModelFace.Bottom)}>
						<FaceSelectBottomIcon />
					</IconButton3D>
				</FlexRow>
			</Popover>
		</>
	);
});

export default FaceSelectMenu;